import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { Observable, of } from 'rxjs';
import { IUser, ILoginData, ICompany, IQuestionnaire } from './types';
import { IInvitation } from 'src/app/modules/logged/invitations/store/types';
import { map, switchMap } from 'rxjs/operators';
import { TokenService } from 'src/app/core/services/token.service';

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {

    constructor(
        private apiService: ApiService,
        private tokenService: TokenService,
    ) { }

    public populate(): Observable<IUser> {
        return this.apiService.get('/user/profile');
    }

    public login(data: any): Observable<ILoginData> {
        return this.apiService.post('/login', data);
    }

    public forgotPassword(data: any): Observable<any> {
        return this.apiService.post('/password/remind', data);
    }

    public setPassword(data: any): Observable<any> {
        return this.apiService.put('/password/remind', data);
    }

    public changePassword(data: any): Observable<any> {
        return this.apiService.put('/user/password', data);
    }

    public refreshToken(refreshToken: string): Observable<ILoginData> {
        return this.apiService.post(`/refresh-token`, { refresh_token: refreshToken }).pipe(
          switchMap((data: ILoginData) => {
            const isLoggedAsCompany = this.tokenService.isLoggedAsCompany();

            if (!isLoggedAsCompany) {
                // delete old token
                this.tokenService.deleteToken({ token: '', refresh_token: refreshToken });

                // set new tokens
                this.tokenService.addToken(data.auth);
            }
            this.tokenService.saveSessionToken(data.auth.token);
            this.tokenService.saveSessionRefreshToken(data.auth.refresh_token);
            return of(data);
          }),
        );
    }

    public fetchCompany(id: string): Observable<ICompany> {
        return this.apiService.get(`/companies/${id}`);
    }

    public fetchCompanyByCode(code: string): Observable<ICompany> {
        return this.apiService.get(`/companies/${code}/find`);
    }

    public fetchInvitation(data: string): Observable<IInvitation> {
        return this.apiService.get(`/subcontractors/invitation/${data}`);
    }

    public getTermsLayout(appType: 'SOVEREIGN' | 'TAXI_DRIVER'): Observable<{ FAQ_html: HTMLElement }> {
        return this.apiService.get(`/faq/html`, { appType });
    }
}
